import React from 'react';
// TODO: define prop types
// import PropTypes from 'prop-types';

import { i18n } from '@lt/localization';
import TouristField from '../TouristField';

export default class TouristDateField extends React.PureComponent {
  render() {
    const { className, ...others } = this.props;
    return (
      <TouristField
        {...others}
        className={className}
        mask="99.99.9999"
        inputmode="numeric"
        placeholder={i18n.t('checkout.touristForm.dateFormat')}
        preventWrongInput
      />
    );
  }
}

TouristDateField.propTypes = {};
